import Route from '@ember/routing/route';

export default class DashboardIndexRoute extends Route {
  activate() {
    return this.controllerFor('dashboard').unsetSelectedUrl();
  }
}
